erpnext.ProductGrid = class {
	/* Options:
		- items: Items
		- settings: E Commerce Settings
		- products_section: Products Wrapper
		- preference: If preference is not grid view, render but hide
	*/
	constructor(options) {
		Object.assign(this, options);

		if (this.preference !== "Grid View") {
			this.products_section.addClass("hidden");
		}

		this.products_section.empty();
		this.make();
	}

	lazy_load_items_prices(settings){
		let me = this;
		var item_codes = this.items.map(p => p.item_code);
		frappe.call({
			method: "erpnext.e_commerce.api.get_website_items_prices",
			args: {
				item_codes: JSON.stringify(item_codes)
			},
			callback: function (data) {
				for(var item_price of data.message){
					var cachedItem = me.cached_items.find(x => x.item_code == item_price.item_code);
					if(!cachedItem){
						continue;
					}
					cachedItem.price = item_price.price;

					var priceHtml = me.get_price_html(cachedItem, settings, false);
					$(`.product-price[data-item-code="${cachedItem.item_code}"]`)
						.html(priceHtml);

					var primaryButtonHtml = me.get_primary_button(cachedItem, settings, false);
					$(`.product-price[data-item-code="${cachedItem.item_code}"]`)
						.append(primaryButtonHtml);
				}
			}
		});
	}

	make() {
		let me = this;
		let html = ``;
		frappe.call({
			method: "erpnext.templates.pages.product_search.get_place_holder",
			args: {},
			async: false,
			callback: (data) => {
				me.cached_items = this.items;
				for (const item of this.items) {
					let title = item.web_item_name || item.item_name || item.item_code || "";
					title = title.length > 90 ? title.substr(0, 90) + "..." : title;

					html += `<div class="item-card-width item-card p-1" style="height: fit-content !important;"><div class="card text-left">`;
					html += me.get_image_html(item, title, data.message.place_holder);
					html += me.get_card_body_html(item, title, me.settings);
					html += `</div></div>`;
				}

				let $product_wrapper = this.products_section;
				$product_wrapper.append(html);
				me.lazy_load_items_prices(me.settings);
				$(".loader-box").remove();

				// Resize Card Photos
				// setTimeout(() => {
				// 	const cards = document.querySelectorAll(".item-card");
				// 	cards.forEach(card => {
				// 		const imgContainer = card.querySelector(".card-img-container");
				// 		const body = card.querySelector(".card-body");
				// 		if (imgContainer && body) {
				// 			const imgHeight = imgContainer.offsetHeight;
				// 			const bodyHeight = body.offsetHeight;
				// 			const maxHeight = bodyHeight * 1.5;

				// 			if (imgHeight > maxHeight) {
				// 				imgContainer.style.maxHeight = `${maxHeight}px`;
				// 				imgContainer.style.overflow = "hidden";
				// 			}
				// 		}
				// 	});
				// }, 100);

			}
		});

		// this.items.forEach((item) => {
		// 	let title = item.web_item_name || item.item_name || item.item_code || "";
		// 	title = title.length > 90 ? title.substr(0, 90) + "..." : title;

		// 	html += `<div class="col-sm-6 col-12 col-md-4 col-lg-3 item-card" style="height: fit-content !important;"><div class="card text-left">`;
		// 	html += me.get_image_html(item, title);
		// 	html += me.get_card_body_html(item, title, me.settings);
		// 	html += `</div></div>`;
		// });

		// let $product_wrapper = this.products_section;
		// $product_wrapper.append(html);
	}

	get_image_html(item, title, place_holder) {
		let image = item.website_image;

		if (image) {
			return `
				<div class="card-img-container">
					<a href="/${item.route || "#"}" style="text-decoration: none;">
						<img class="card-img lazyload" src="${image}" alt="${title}">
					</a>
					${this.get_variants(item)}
				</div>
			`;
		} else {
			return `
				<div class="card-img-container">
						<a class="card-placeholder-link" href="/${item.route || '#'}" style="text-decoration: none;">
							<img class="card-img placeholder-img lazyload" src="${place_holder}" alt="${title}">
						</a>
						${this.get_variants(item)}
				</div>
			`;
		}
	}

	get_card_body_html(item, title, settings) {		
		let body_html = `
			<div class="card-body text-left card-body-flex" style="width:100%">
				<div style="margin-top: 1rem; display: flex;flex-direction: column">
		`;
		body_html += `<div class="d-flex delivery-detail-box">`;
		body_html += `<div class="col-4 p-0">${this.get_stock_availability(item, settings)}</div>`;
		body_html += `<div class="col-4 p-0">${this.get_gift(item)}</div>`;
		if(item.engrave){
			body_html += `<div class="col-4 p-0">${this.get_engrave(item)}</div>`;
		}
		else{

		}
		body_html += `</div>`


		body_html += this.get_title(item, title);
		// get floating elements
		if (!item.has_variants) {
			if (settings.enable_wishlist) {
				body_html += this.get_wishlist_icon(item);
			}
			if (settings.enabled) {
				body_html += this.get_cart_indicator(item);
			}
		}
		
		body_html += `</div>`;
		body_html += this.get_original_name(item);
		body_html += `<div class="product-category">${item.item_group || ""}</div>`;

		body_html += this.get_price_html(item, settings);
		

		body_html += this.get_primary_button(item, settings);
		body_html += `</div>`; // close div on line 49

		return body_html;
	}
	get_original_name(item){

		let original_name_html = `
		<div style="direction: rtl !important; font-size: 11px !important; font-weight:500">
			<a href="/${item.route || "#"}" ">
				<div class="product-original-name mt-2" style="min-height: 20px;display: flex; align-items: center;">
					${item.original_name || ""}
				</div>
			</a>
		</div>
		`;
		return original_name_html;

	}
	get_title(item, title) {
		let title_html = `
			<a href="/${item.route || "#"}">
				<div class="product-title">
					${title || ""}
				</div>
			</a>
		`;
		return title_html;
	}

	get_wishlist_icon(item) {
		let icon_class = item.wished ? "wished" : "not-wished";
		return `
			<div class="like-action ${item.wished ? "like-action-wished" : ""}"
				data-item-code="${item.item_code}">
				<i class="bi bi-heart-fill"></i>
			</div>
		`;
	}

	get_cart_indicator(item) {
		return `
			<div class="cart-indicator ${item.in_cart ? "" : "hidden"}" data-item-code="${item.item_code}">
				1
			</div>
		`;
	}

	get_price_html(item, settings, put_loader = true) {

		if(put_loader){
			return `
				<div class="product-price" data-item-code="${item.item_code}">
					<div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
				</div>
			`
		}
		

		let price_html = ``

		if (!item.in_stock && !item.allow_seller){
			price_html += `
				<span class="out-of-stock my-2 d-flex align-items-center">
				<p class="col" style=" border-bottom: 1px solid var(--primary); display: flex; width: -webkit-fill-available;height: fit-content;"></p>
		 			<span class="px-2" style="color: #212121 !important;font-weight: 700 !important;font-size: 16px !important;">ناموجود</span>
		 		<p class="col" style=" border-bottom: 1px solid var(--primary); display: flex; width: -webkit-fill-available;height: fit-content;"></p>
				</span>
	
			`;
			return price_html;
		}

		if (item.show_price && settings.show_price && item.price.formatted_price) {
			price_html += `
				<div class="product-price my-2">
				
					${item.price.formatted_price.replace("تومان ", "") + " تومان"}
	
			`;
	
			if (item.price.formatted_mrp) {
				price_html += `
					<small class="striked-price">
						<s>${item.price.formatted_mrp ? item.price.formatted_mrp.replace("تومان ", "") + " تومان": "" }</s>
					</small>
					<small class="product-info-green">
						${item.price.discount_percent}%
					</small>
				`;
			}
			price_html += `</div>`;

		} 
		else 
		{
			price_html += `<div class="product-price my-2">
				<span>${settings.priceless_item_text ? settings.priceless_item_text : "تماس بگیرید"}</span>
			</div>`;
		}

		return price_html;
	}

	get_engrave(itme){
		return`
			<div class="out-of-stock flex-column" style="text-align: center"><i class="bi bi-pen" style="color: #ABABAB;font-size: 18px !important;"></i><span style="color: #636161 !important;font-weight: 500 !important;font-size: 12px !important;line-height:18px;">حکاکی</span></div>
			`;

	}

	get_variants(item){

		var html = "";
		var new_html = "";

		if (item.variants){
			var routes = []
			item.variants.forEach(function(d) {
				if(d.all_colors){
					d.all_colors.forEach(function (data) {
						if(routes.indexOf(data.object_route) === -1){
							routes.push(data.object_route)
							html += `<a style="padding: 1px; display: flex; border-radius: 50%;width:fit-content !important; margin: 1px; border-width: 0px; border-style: solid; border-color:${data.color};"
										href="${data.object_route}"
										onmouseover="this.style.borderWidth='1px'; this.style.margin='0';"
										onmouseout="this.style.borderWidth='0px'; this.style.margin='1px';">
										<span style="background-color:${data.color};width: 8px; height: 8px; border-radius: 50%; padding: 4px; cursor: pointer;">
										</span>
									</a>`;
						}

					})
					
				}

			});
			
		}

		new_html += `<div class="d-flex justify-content-end flex-column">${html}</div>`
		
		let attrHtml = '';
		if (item.variants){

			item.variants.forEach(function(d){
	
				Object.keys(d).forEach(function (key) {
					if (key !== 'web_name' && key !== 'Colour' && key !== 'all_colors') {
						d[key].forEach(function (data) {
							attrHtml += `<a class="attr-pill-value" style="background-color: #cccccc83; width: fit-content; padding: 4px 8px; border-radius: 50px; color: gray; font-size: 10px;" href="${data.object_route}">
								<div>${data.value}</div>
							</a>`;
						});
			
						// Append each attribute's section to the main HTML string
					}
				});
			})
			new_html += `
					 <div class="d-flex flex-wrap" style="gap: 8px;">${attrHtml}</div>`;
		}
	

		
		var colorRow = `<div class="d-flex flex-column" style="gap:4px; justify-content: end;">
			${new_html}
		</div>`;


		var color_and_gift = ""

		if (item.gift){

			color_and_gift += `<div class="d-flex flex-column align-items-center justify-content-center var-color-card-box" style="position: absolute; right: 6px; top: 20px;">${colorRow}</div>`

		}else{
			color_and_gift += `<div class="d-none flex-column align-items-center justify-content-center" style="min-height:26px !important">${colorRow} </div>`
		}

		return color_and_gift;
	}

	get_gift(item){
		var new_html = "";

		var color_and_gift = ""

		if (item.gift){

			color_and_gift += `<div class="d-flex flex-column justify-content-between align-items-center"><i class="bi bi-gift-fill" style="color: #ABABAB;font-size: 18px !important;"></i><span style="color: #636161 !important;font-weight: 500 !important;font-size: 12px !important;line-height:18px;">کادو</span></div>`

		}else{
			color_and_gift += `<div class="d-flex justify-content-end align-items-center" style="min-height:26px !important"></div>`
		}

		return color_and_gift;
	}

	get_stock_availability(item, settings) {
		if (item.is_digital == 1){
			return `
					<span class="out-of-stock flex-column">
						${""}
					</span>
					`;
		}
		if (settings.show_stock_availability && !item.has_variants) {
			if (settings.show_stock_availability && item.in_stock && !item.allow_seller){
				return `
						<span class="out-of-stock flex-column">
						<i class="bi bi-truck" style="color: #ABABAB;font-size: 18px !important;"></i>
							<span style="color: #636161 !important;font-weight: 500 !important;font-size: 12px !important;line-height:18px;">ارسال فوری</span>
						</span>
						`;
			}
			if (item.on_backorder) {
				return`
					<span class="out-of-stock flex-column">
					<i class="bi bi-box-seam" style="color: #ABABAB;font-size: 18px !important;"></i>
						<span style="color: #636161 !important;font-weight: 500 !important;font-size: 12px !important;line-height:18px;">${__("Available on backorder")}</span>
					</span>
				`;
				// return `
				// 	<span class="out-of-stock mb-2 mt-1 flex-column" style="color: var(--primary-color)">
				// 		 ${__("Available on backorder")}
				// 	</span>
				// `;
			}

			 if (item.allow_seller) {
				if (settings.seller_description) {

					return `
						<span class="out-of-stock flex-column">
						<i class="bi bi-truck" style="color: #ABABAB;font-size: 18px !important;"></i>
							<span style="color: #636161 !important;font-weight: 500 !important;font-size: 12px !important;line-height:18px;">${__(settings.seller_description)}</span>
						</span>
					`;
				}

			} else{
				return``
			}
		}
		
	}

	get_primary_button(item, settings, put_loader = true) {

		if(put_loader){
			return ``;
		}

		if (item.has_variants) {
			return `
				<a href="/${item.route || '#'}">
					<div class="btn btn-sm btn-explore-variants w-100 mt-4">
						${'بررسی'}
					</div>
				</a>
			`;
		} else if (settings.enabled && item.show_price && settings.show_price && (settings.allow_items_not_in_stock || item.in_stock || item.allow_seller)) {
			// return `
			// 	<div id="${item.name}" class="btn
			// 		btn-sm btn-primary btn-add-to-cart-list
			// 		w-100 mt-2 ${item.in_cart ? 'hidden' : ''}"
			// 		data-item-code="${item.item_code}">
			// 		<span class="mr-2">
			// 			<svg class="icon icon-md">
			// 				<use href="#icon-assets"></use>
			// 			</svg>
			// 		</span>
			// 		${settings.enable_checkout ? __('Add to Cart') : __('Add to Quote')}
			// 	</div>

			// 	<a href="/cart">
			// 		<div id="${item.name}" class="btn
			// 			btn-sm btn-primary btn-add-to-cart-list
			// 			w-100 mt-4 go-to-cart-grid
			// 			${item.in_cart ? '' : 'hidden'}"
			// 			data-item-code="${item.item_code}">
			// 			${settings.enable_checkout ? __('Go to Cart') : __('Go to Quote')}
			// 		</div>
			// 	</a>
			// `;
			return `
				<div id="${item.name}" class="btn
					btn-sm btn-primary btn-add-to-cart-list
					w-100 mt-2 ${item.in_cart ? 'hidden' : ''}"
					data-item-code="${item.item_code}">
					
					${settings.enable_checkout ? 'اضافه کردن به سبد خرید' : 'اضافه کردن به پیش سفارش'}
				</div>

				<a href="/cart">
					<div id="${item.name}" class="btn
						btn-sm btn-primary btn-add-to-cart-list
						w-100 mt-4 go-to-cart-grid
						${item.in_cart ? '' : 'hidden'}"
						data-item-code="${item.item_code}">
						${settings.enable_checkout ? 'رفتن به سبد خرید' : 'رفتن به پیش سفارش'}
					</div>
				</a>
			`;
		} else if (!item.show_price || !settings.show_price) {
			return `
				<div id="${item.name}" 
					class="btn btn-sm w-100 ${item.in_cart ? 'hidden' : ''}" 
					data-item-code="${item.item_code}" 
					style="pointer-events: none; opacity: 0.5; cursor: not-allowed; box-shadow: unset !important;">
					<span class="mr-2">
						<svg class="icon icon-md"></svg>
					</span>
				</div>

				`
		} else {
			return `
				<button id="${item.name}" class="btn
					btn-sm btn-primary btn-add-to-cart-list
					w-100 mt-2 ${item.in_cart ? 'hidden' : ''}"
					data-item-code="${item.item_code}" disabled aria-disabled="true" style="border: unset !important;box-shadow: unset !important; outline: unset !important;">
					
					${settings.enable_checkout ? 'اضافه کردن به سبد خرید' : 'اضافه کردن به پیش سفارش'}
				</button>
			`;
		}
	}
};
